/**
 * MintProgressBar
 *
 * Displays mint progress as "X / Y (Z%)" with a progress bar.
 */

import React from 'react';

export interface MintProgressBarProps {
  mintedCount: number;
  totalSupply: number | null;
  className?: string;
}

export const MintProgressBar: React.FC<MintProgressBarProps> = ({
  mintedCount,
  totalSupply,
  className = '',
}) => {
  const progress = totalSupply && totalSupply > 0
    ? Math.round((mintedCount / totalSupply) * 100)
    : 0;

  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-body text-subtext-color">Minted</span>
        <span className="text-body-bold font-body-bold text-default-font">
          {mintedCount.toLocaleString()} / {totalSupply?.toLocaleString() || '?'} ({progress}%)
        </span>
      </div>
      <div className="h-2 bg-neutral-200 dark:bg-neutral-700 rounded-full overflow-hidden">
        <div
          className="h-full bg-brand-500 rounded-full transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
